import NormeDetailController from './norme.detail.controller';

export default {
    template: require('./norme.detail.html'),
    controller: NormeDetailController
};
